import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const Input = styled.input`
  box-sizing: border-box;

  display: block;
  width: 100%;
  height: 3em;

  margin-top: 0;
  padding: 0.25em 0.75em 0.25em 0.25em;

  border: 2px solid var(--juno-color-border);
  border-radius: 0;

  font-size: var(--juno-font-size-body-sm);
  line-height: 1.5rem;
  font-weight: var(--juno-font-weight-light);
  appearance: none;

  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
    line-height: 2.1875rem;
  }

  &:focus-visible {
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
  }

  ${(props) =>
    props.error &&
    css`
      border-width: 4px;
      border-color: var(--juno-color-error);
    `};

  ${(props) =>
    props.size === "large" &&
    css`
      max-width: 15em;
    `};

  ${(props) =>
    props.size === "medium" &&
    css`
      max-width: 11.25em;
    `};

  ${(props) =>
    props.size === "small" &&
    css`
      max-width: 7.5em;
    `};

  ${(props) =>
    props.disabled &&
    css`
      font-weight: var(--juno-font-weight-bold);
      background: none;
    `};
`;

export default Input;
